/*
 * Copyright 2023, Corning Optical Communications
 * All Rights Reserved.
 */

import { ISearchState } from "./type";
import { PayloadAction } from "@reduxjs/toolkit";

interface ISearchScopePayload {
  scope: string;
  keyword?: string;
}

export const updateSearchKeywordAction = (
  state: ISearchState | any,
  action: PayloadAction<string>
) => {
  state.searchedKeyword = action.payload;
};

export const updateSearchKeywordForScopeAction = (
  state: ISearchState | any,
  action: PayloadAction<ISearchScopePayload>
) => {
  const { scope, keyword } = action.payload;
  if (!scope) {
    return;
  }
  if (!state.scopedKeywords) {
    state.scopedKeywords = {};
  }
  state.scopedKeywords[scope] = keyword || "";
};

export const resetSearchKeywordAction = (state: ISearchState) => {
  state.searchedKeyword = "";
};

export const resetSearchKeywordForScopeAction = (
  state: ISearchState | any,
  action: PayloadAction<ISearchScopePayload>
) => {
  const { scope } = action.payload;
  if (!scope) {
    return;
  }
  if (!state.scopedKeywords) {
    state.scopedKeywords = {};
  }
  state.scopedKeywords[scope] = "";
};

export const updatePageAction = (
  state: ISearchState | any,
  action: PayloadAction<string>
) => {
  state.searchedKeyword = "";
  state.page = action.payload;
};
